@if (hasContent) {
      <div [class]="contentClasses()">
        <ng-content></ng-content>
      </div>
    }
